import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2f117b1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "navbar navbar-expand-md navbar-light bg-light" };
const _hoisted_2 = { class: "container-fluid" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    id: "hamburger-button",
    class: "navbar-toggler",
    type: "button",
    "aria-controls": "navbarSupportedContent",
    "aria-expanded": "false",
    "aria-label": "Toggle navigation",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#navbarSupportedContent"
}, [
    /*#__PURE__*/ _createElementVNode("span", { class: "navbar-toggler-icon" })
], -1));
const _hoisted_4 = {
    class: "collapse navbar-collapse",
    id: "navbarSupportedContent"
};
const _hoisted_5 = { class: "navbar-nav me-auto mb-2 mb-lg-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MenuLevel1 = _resolveComponent("MenuLevel1");
    return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuDataSorted, (menuDatum) => {
                        return (_openBlock(), _createBlock(_component_MenuLevel1, {
                            key: menuDatum.text,
                            menuData: menuDatum
                        }, null, 8, ["menuData"]));
                    }), 128))
                ])
            ])
        ])
    ]));
}
